<template>
  <div v-if="isLoading" class="global-loading-overlay">
    <div class="loader"></div>
  </div>
</template>

<script setup lang="ts">
import { useLoadingStore } from "@/store/loading";

const loadingStore = useLoadingStore();
const { isLoading } = storeToRefs(loadingStore);
</script>

<style scoped>
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

/* HTML: <div class="loader"></div> */
.loader {
  height: 80px;
  aspect-ratio: 1;
  box-sizing: border-box;
  position: relative;
  --spinner-color: rgb(45 85 110 / var(--tw-bg-opacity, 1));
  mask:
    radial-gradient(#0000 47%, var(--spinner-color) 48% 71%, #0000 72%) exclude,
    conic-gradient(var(--spinner-color) 0 0) no-clip;
  animation: l11 1.5s linear infinite;
}

.loader:before {
  content: "";
  position: absolute;
  inset: 0 35% 70%;
  border-radius: 50%;
  background: rgb(45 85 110 / var(--tw-bg-opacity, 1));
  filter: blur(15px);
}

@keyframes l11 {
  to {
    rotate: 1turn;
  }
}
</style>
